import React from 'react';
import { Tabs } from 'antd';
import FlatsGrid from '../FlatsGrid/FlatsGrid';
import styles from './ChessCardsTabs.module.scss';

const { TabPane } = Tabs;

const ChessCardsTabs = ({ entrances }) => {
  return (
    <Tabs
      defaultActiveKey={entrances[0].name}
      className={styles.root}
      tabPosition="bottom"
      tabBarGutter={15}
    >
      {entrances.map((entrance) => (
        <TabPane tab={entrance.name} key={entrance.name}>
          <FlatsGrid className={styles.chessCard} data={entrance} isPreview />
        </TabPane>
      ))}
    </Tabs>
  );
};

export default ChessCardsTabs;
